<template>
    <div
        :class="['podium-pro', { 'hero-margin-top': applyHeroBannerBetaStyle }]"
    >
        <component
            :is="isPartnerRowZeta ? 'PodiumCardZeta' : 'PodiumCardDefault'"
            v-for="(partner, index) in partners"
            :partner="partner"
            :index="index"
            :key="index"
            v-bind="{ ...cardProps }"
        />
    </div>
</template>

<script>
import PodiumCardDefault from '@molecules/PodiumPro/PodiumCardDefault.vue';
import PodiumCardZeta from '@molecules/PodiumPro/PodiumCardZeta.vue';
import { PodiumProProps } from '@molecules/PodiumPro/PodiumPro.props';
export default {
    name: 'PodiumPro',
    components: {
        PodiumCardDefault,
        PodiumCardZeta,
    },
    props: {
        partners: {
            type: Array,
            required: true,
        },
        applyHeroBannerBetaStyle: {
            type: Boolean,
            default: false,
        },
        ...PodiumProProps,
    },
    computed: {
        cardProps() {
            const { partners, ...otherProps } = this.$props;
            return otherProps;
        },
    },
};
</script>

<style lang="scss" scoped>
.podium-pro {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    margin-top: -80px;
    align-items: center;

    .podium-card:nth-child(1) {
        order: 2;
    }
    .podium-card:nth-child(2) {
        order: 1;
    }
    .podium-card:nth-child(3) {
        order: 3;
    }
}

.hero-margin-top {
    margin-top: 35px;
}
</style>
